import React, { Component } from 'react';
import { withFirebase } from '../Firebase';
import like_picture from "../../assets/cards/like_icon.svg"
import like_picture_white from "../../assets/cards/like_icon_white.svg"
import * as firebase from 'firebase';


class LikeIdeaComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { idea: [], click: false, nbLikes: 0, likeList: [], hadLike: null, user: "" }
    }

    componentDidMount() {
        let uid;

        if (this.props.firebase.auth.currentUser && this.props.idcapsule) {
            this.setState({ idCapsule: this.props.idCapsule })
            uid = this.props.firebase.auth.currentUser.uid
            this.props.firebase.db.collection('capsules').doc(this.props.idcapsule).collection('ideas').doc(this.props.ideaId).get()
                .then((doc) => {
                    if (doc.data()) {
                        this.setState({
                            idea: doc.data(), nbLikes: doc.data().nbLikes, likeList: doc.data().likeList,
                            hadLike: doc.data().likeList.includes(uid), user: uid
                        });
                    }
                })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.idcapsule !== this.state.idCapsule) {
            this.refreshLikes(nextProps.idcapsule, nextProps.ideaId)
        }
    }

    refreshLikes(idCapsule, ideaId) {
        let uid = this.props.firebase.auth.currentUser.uid
        this.props.firebase.db.collection('capsules').doc(idCapsule).collection('ideas').doc(ideaId).get()
            .then((doc) => {
                if (doc.data()) {
                    this.setState({
                        idea: doc.data(), nbLikes: doc.data().nbLikes, likeList: doc.data().likeList,
                        hadLike: doc.data().likeList.includes(uid), user: uid
                    });
                }
            })
    }

    addLike = () => {
        const { click, nbLikes, likeList, hadLike, user } = this.state;
        let likes = nbLikes || 0;
        if (click === false && hadLike === false) {
            likeList.push(user);
            likes += 1;
            this.setState({ click: true, nbLikes: likes, likeList })
        }
        this.props.firebase.db.collection('capsules').doc(this.props.idcapsule).collection('ideas').doc(this.props.ideaId).set({ nbLikes: likes, likeList: likeList }, { merge: true })
        this.props.firebase.db.collection('capsules').doc(this.props.idcapsule).update({ nbLikeIdeas: firebase.firestore.FieldValue.increment(1) })
    }

    render() {
        const { nbLikes, click, hadLike } = this.state
        return (
            <>
                <div hidden={click === true || hadLike === true} onClick={this.addLike} className="btn-like-com cursor-pointer">
                    <div className="idea-number-like-grey mr-2">{nbLikes}</div>
                    <img src={like_picture} alt="Like" />
                </div>
                <div hidden={hadLike === false && click === false} className="btn-like-grey-com">
                    <div className="idea-number-like-white mr-2">{nbLikes}</div>
                    <img src={like_picture_white} alt="Like" />
                </div>
            </>
        );
    }
}


export default withFirebase(LikeIdeaComponent);